const API_BASE_URL = import.meta.env.VITE_API_URL || '';

export const fetch: typeof window.fetch = (input, init?) => {
  let url: string;

  if (typeof input === 'string') {
    url = input;
  } else if (input instanceof Request) {
    url = input.url;
  } else {
    url = input;
  }

  if (url && typeof url === 'string' && url.startsWith('/api') && API_BASE_URL) {
    url = `${API_BASE_URL}${url}`;
  }

  const finalInit = {
    ...init,
    credentials: 'include' as RequestCredentials,
  };

  return globalThis.fetch(url, finalInit);
};
